<template>
  <div class="cats">
    <h2>Unique Kitties</h2>
    <div ref="catref">
      <cat
        v-for="cat in cats"
        :cat="cat"
        >
      </cat>
    </div>
  </div>
</template>


<script>

import Masonry from 'masonry-layout';
import Cat from './Cat';
import CatRepository from '../../data/CatRepository';
import firebase from 'firebase';

export default {
  components: {
    Cat,
  },

  props: ['title'],

  data() {
    return {
      cats: [],
    };
  },

  watch: {
    cats: {
      handler() {
        this.$nextTick(() => {
          this.masonry.reloadItems();
          this.masonry.layout();
        });
      },
      deep: true,
    },
  },

  mounted() {

    this.masonry = new Masonry(this.$refs.catref, {
      itemSelector: '.cat',
      gutter: 32,
    });

    CatRepository.on('added', (cat) => {
      if (cat.number === 0) {
        this.cats.unshift(cat);
      }
    });

    CatRepository.on('changed', ({ key, title, content }) => {
      const outdatedCat = CatRepository.find(this.cats, key);
      if (outdatedCat && outdatedCat.number === 0) {
        cats.filter(a => a.key != key)
      }
    });
  },
};
</script>

<style>
  .cats {
    transition: transform 1s;
    margin-top: 50px;
  }
</style>



// WEBPACK FOOTER //
// Unique.vue?a975328a